import React from 'react';
import * as S from './style';
import { FormItem, Label } from 'components';
import { Props as TextAreaProps } from 'components/atoms/TextArea';
import {
  LABEL_INTRODUCE,
  PLACEHOLDER_INTRODUCE,
  CAPTION_INTRODUCE_1,
  CAPTION_INTRODUCE_2,
  CAPTION_INTRODUCE_3,
} from 'commons/ZimssaString';

export interface Props extends TextAreaProps {
  placeholder?: string;
}

function Introduce({ placeholder, ...props }: Props): React.ReactElement {
  const captionProps = {
    fontStyle: 'caption',
    color: 'gray_opacity_400',
  };
  const captionContents = [
    CAPTION_INTRODUCE_1,
    CAPTION_INTRODUCE_2,
    CAPTION_INTRODUCE_3,
  ];
  return (
    <FormItem
      label={LABEL_INTRODUCE}
      caption={captionContents.map((item, index) => (
        <Label key={index} contents={item} {...captionProps} />
      ))}
    >
      <S.TextAreaIntroduce
        placeholder={placeholder ? placeholder : PLACEHOLDER_INTRODUCE}
        {...props}
      />
    </FormItem>
  );
}

export default Introduce;
